// Generated by purs version 0.15.0
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
var mapUnwrapFlipped = function (dictFunctor) {
    return function () {
        return function (x) {
            return function (f) {
                return Data_Functor.map(dictFunctor)((function () {
                    var $2 = Data_Newtype.unwrap();
                    return function ($3) {
                        return f($2($3));
                    };
                })())(x);
            };
        };
    };
};
var mapUnwrap = function (dictFunctor) {
    return function () {
        return function (f) {
            return function (x) {
                return Data_Functor.map(dictFunctor)((function () {
                    var $4 = Data_Newtype.unwrap();
                    return function ($5) {
                        return f($4($5));
                    };
                })())(x);
            };
        };
    };
};
var composeUnwrapRes = function () {
    return function (g) {
        return function (f) {
            return function (x) {
                return Data_Newtype.unwrap()(g(f(x)));
            };
        };
    };
};
var composeUnwrapFunRes = function () {
    return function () {
        return function (g) {
            return function (f) {
                return function (x) {
                    return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(x))));
                };
            };
        };
    };
};
var composeUnwrapFun = function () {
    return function (g) {
        return function (f) {
            return function (x) {
                return g(Data_Newtype.unwrap()(f(x)));
            };
        };
    };
};
var composeUnwrapArgFunRes = function () {
    return function () {
        return function () {
            return function (g) {
                return function (f) {
                    return function (x) {
                        return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)))));
                    };
                };
            };
        };
    };
};
var composeUnwrapArgFun = function () {
    return function () {
        return function (g) {
            return function (f) {
                return function (x) {
                    return g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x))));
                };
            };
        };
    };
};
var composeUnwrapArg = function () {
    return function (g) {
        return function (f) {
            return function (x) {
                return g(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var composeFlippedUnwrapRes = function () {
    return function (f) {
        return function (g) {
            return function (x) {
                return Data_Newtype.unwrap()(g(f(x)));
            };
        };
    };
};
var composeFlippedUnwrapFunRes = function () {
    return function () {
        return function (f) {
            return function (g) {
                return function (x) {
                    return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(x))));
                };
            };
        };
    };
};
var composeFlippedUnwrapFun = function () {
    return function (f) {
        return function (g) {
            return function (x) {
                return g(Data_Newtype.unwrap()(f(x)));
            };
        };
    };
};
var composeFlippedUnwrapArgFunRes = function () {
    return function () {
        return function () {
            return function (f) {
                return function (g) {
                    return function (x) {
                        return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)))));
                    };
                };
            };
        };
    };
};
var composeFlippedUnwrapArgFun = function () {
    return function () {
        return function (f) {
            return function (g) {
                return function (x) {
                    return g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x))));
                };
            };
        };
    };
};
var composeFlippedUnwrapArg = function () {
    return function (f) {
        return function (g) {
            return function (x) {
                return g(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var applyUnwrappedFlipped = function () {
    return function (x) {
        return function (f) {
            return f(Data_Newtype.unwrap()(x));
        };
    };
};
var applyUnwrapped = function () {
    return function (f) {
        return function (x) {
            return f(Data_Newtype.unwrap()(x));
        };
    };
};
var applyUnwrapUnwrappedFlipped = function () {
    return function () {
        return function (x) {
            return function (f) {
                return Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var applyUnwrapUnwrapped = function () {
    return function () {
        return function (f) {
            return function (x) {
                return Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var applyUnwrapFlipped = function () {
    return function (x) {
        return function (f) {
            return Data_Newtype.unwrap()(f(x));
        };
    };
};
var applyUnwrap = function () {
    return function (f) {
        return function (x) {
            return Data_Newtype.unwrap()(f(x));
        };
    };
};
export {
    applyUnwrapped,
    applyUnwrap,
    applyUnwrapUnwrapped,
    applyUnwrappedFlipped,
    applyUnwrapFlipped,
    applyUnwrapUnwrappedFlipped,
    composeUnwrapRes,
    composeUnwrapArg,
    composeUnwrapFun,
    composeUnwrapFunRes,
    composeUnwrapArgFun,
    composeUnwrapArgFunRes,
    composeFlippedUnwrapArg,
    composeFlippedUnwrapRes,
    composeFlippedUnwrapFun,
    composeFlippedUnwrapArgFun,
    composeFlippedUnwrapFunRes,
    composeFlippedUnwrapArgFunRes,
    mapUnwrap,
    mapUnwrapFlipped
};
//# sourceMappingURL=index.js.map
